import React from 'react'
/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import StackTrace from 'stacktrace-js'
import { GenericModal } from 'core'
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false, errorMsg: '', errorStack: [] }
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, errorMsg: String(error) }
  }

  componentDidCatch(errorMsg) {
    StackTrace.get().then(errorStack =>
      this.setState({ errorMsg: String(errorMsg), errorStack })
    )
  }

  render() {
    if (this.state.hasError) {
      return (
        <GenericModal
          open={this.state.hasError}
          title="Error"
          onClose={_ => this.setState({ hasError: false })}
        >
          {_ => (
            <div>
              <b>An error has occured. </b>
              <br />
              <b>Kindly report the below error message to your IT team.</b>
              <br />
              {this.state.errorMsg}
              {this.state.errorStack.map(s => (
                <>
                  <br />
                  {s.fileName}.{s.functionName} ({s.lineNumber},{s.columnNumber}
                  )
                </>
              ))}
            </div>
          )}
        </GenericModal>
      )
    }

    return this.props.children
  }
}

export default ErrorBoundary
